class Utils {
  /**
   * @param {int} max
   * @returns int
   */
  getRandomNumber(max) {
    return parseInt(Math.floor(Math.random() * max));
  }

  /**
   * @param {int} count Number of numbers to return
   * @param {max} max Max range
   * @returns array
   */
  getRandomNumbers(count, max) {
    const numbers = [];

    do {
      const index = this.getRandomNumber(max);

      if (numbers.indexOf(index) === -1) {
        numbers.push(index);
      }
    } while(numbers.length < count);

    return numbers;
  }

  /**
   * @returns {string}
   */
  getCurrentTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return '';
    }
  }

  getDateString(date) {
    date = this.getDateISOString(date);

    if (! date) {
      return '';
    }

    const parts = date.split('T');

    if (! parts[0] || null === parts[0].match(/^\d{4}-\d{2}-\d{2}$/)) {
      return '';
    }

    return parts[0];
  }

  getDateISOString(date) {
    if (date instanceof Date) {
      return date.toISOString();
    }

    if ('string' !== typeof date) {
      return '';
    }

    if (null === date.match(/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/)) {
      return '';
    }

    return date;
  }

  isVisible(element, offset = 0) {
    const elementTop = element.offset().top - offset;
    const elementBottom = elementTop + element.outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  isVisibleExperimental(element, offset = 0) {
    const rect = element[0].getBoundingClientRect();

    return (
      rect.bottom + offset >= 0 &&
      rect.top - offset <= $(window).height()
    );
  }

  isTopVisible(element, offset = 0) {
    const elementTop = element.offset().top - offset;
    const viewportBottom = $(window).height() + $(window).scrollTop();

    return elementTop < viewportBottom;
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  }

  formatDate(date) {
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();
    let year = date.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  setStickySidebar(sidebar) {
    if (sidebar.length) {
      let height = 0;

      sidebar.children().each((i, child) => {
        height += $(child).outerHeight(true);
      });

      sidebar.css('top', (height - window.innerHeight) * -1 + 'px');
      sidebar.css('position', 'sticly');
    }
  }
}

export default Utils;
